// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.generate-parent {
  width: 100%;
}

.insights-page-root {
  padding: 25px 25px 25px 45px;
  font-family: "Source Sans Pro", sans-serif;
  color: #373f50;
}
.insights-page-root .generate-parent {
  margin-bottom: 23px;
}
.insights-page-root .insights-page-title {
  font-style: normal;
  font-weight: 400;
  font-size: 30px;
  line-height: 38px;
  letter-spacing: 0.0025em;
  margin-bottom: 23px;
}
.insights-page-root .insights-info-message {
  font-size: 16px;
  line-height: 20px;
  letter-spacing: 0.005em;
  margin-bottom: 14px;
}
.insights-page-root .insights-list-container {
  max-height: calc(100vh - 441px);
  overflow-y: auto;
}
.insights-page-root .insights-list-container::-webkit-scrollbar {
  width: 5px;
}
.insights-page-root .insights-list-container::-webkit-scrollbar-track {
  border-radius: 10px;
}
.insights-page-root .insights-list-container::-webkit-scrollbar-thumb {
  background: #909BB3;
  border-radius: 2.5px;
  width: 5px;
}
.insights-page-root .insights-list-container .insights-list {
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
}

.advanced-options-container {
  display: flex;
  flex-flow: column nowrap;
  justify-content: flex-start;
  align-items: flex-start;
  padding: 20px;
}
.advanced-options-container .dj-label {
  font-size: 16px;
  line-height: 20px;
  margin-bottom: 4px;
}
.advanced-options-container .dj-label.error {
  color: #B00020;
}
.advanced-options-container .dj-input {
  width: 464px;
  height: 48px;
  font-size: 20px;
  line-height: 25px;
  background: #FFFFFF;
  border: 1px solid #D3D7E0;
  border-radius: 3px;
  margin-bottom: 6px;
  padding-left: 16px;
}
.advanced-options-container .dj-input::placeholder {
  color: #909BB3;
}
.advanced-options-container .dj-input.error {
  color: #B00020;
  border: 1px solid #B00020;
}
.advanced-options-container .dj-input.error::placeholder {
  color: #B00020;
}
.advanced-options-container .helper-text {
  font-size: 12px;
  line-height: 15px;
  letter-spacing: 0.0125em;
  color: #373F50;
}
.advanced-options-container .location-language-container {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: space-between;
}

.generate-insight-width-control {
  max-width: 700px;
}

.generate-insight-container {
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
}
.generate-insight-container .generate-input-dropdown {
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  align-items: center;
  border: 1px solid #D3D7E0;
  border-radius: 3px;
  height: 48px;
  width: 100%;
  font-size: 20px;
  line-height: 25px;
  display: flex;
  align-items: center;
  letter-spacing: 0.0125em;
}
.generate-insight-container .generate-input-dropdown.focused {
  border: 1px solid #008CCE;
}
.generate-insight-container .generate-input-dropdown.error {
  border: 1px solid #B00020;
}
.generate-insight-container .generate-input-dropdown .insight-input {
  box-sizing: border-box;
  border: none;
  border-radius: 0;
  border-right: 1px solid #D3D7E0;
  font-size: 20px;
  line-height: 25px;
  width: 65%;
  padding: 10px 16px 10px 16px;
}
.generate-insight-container .generate-input-dropdown .insight-input::placeholder {
  color: #909BB3;
}
.generate-insight-container .generate-input-dropdown .insight-input:focus {
  outline: none;
}
.generate-insight-container .generate-input-dropdown .insight-input.focused {
  border-right: 1px solid #008CCE;
}
.generate-insight-container .generate-input-dropdown .insight-input.error {
  border-right: 1px solid #B00020;
}
.generate-insight-container .generate-input-dropdown .insight-input.error::placeholder {
  color: #B00020;
}
.generate-insight-container .generate-input-dropdown .dropdown-button {
  box-sizing: border-box;
  background-color: #FFFFFF;
  color: #909BB3;
  border: none;
  font-size: 20px;
  line-height: 25px;
  width: 35%;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: center;
  padding: 10px 5px;
  max-height: 100%;
}
.generate-insight-container .generate-input-dropdown .dropdown-button.error {
  color: #B00020;
}
.generate-insight-container .generate-button {
  padding: 10px;
  height: 48px;
  background: #008CCE;
  border-radius: 3px;
  color: #FFFFFF;
  margin-left: 16px;
  font-weight: 600;
  font-size: 20px;
  line-height: 25px;
  font-family: "Source Sans Pro", sans-serif;
  border: none;
}
.generate-insight-container .generate-button:hover {
  box-shadow: 0px 4px 8px rgba(55, 63, 80, 0.25);
}
.generate-insight-container .generate-button:active {
  background: #2ABBFF;
  box-shadow: 0px 0px 3px #008CCE;
}
.generate-insight-container .generate-button:disabled {
  background: #D3D7E0;
  color: rgba(55, 63, 80, 0.3);
}`, "",{"version":3,"sources":["webpack://./src/components/insights/insights.scss"],"names":[],"mappings":"AAGA;EACE,WAAA;AAFF;;AAIA;EACE,4BAAA;EACA,0CAAA;EACA,cATW;AAQb;AAGE;EACE,mBAAA;AADJ;AAKE;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,wBAAA;EACA,mBAAA;AAHJ;AAKE;EACE,eAAA;EACA,iBAAA;EACA,uBAAA;EACA,mBAAA;AAHJ;AAOE;EACE,+BAAA;EACA,gBAAA;AALJ;AAMI;EACE,UAAA;AAJN;AAMI;EACE,mBAAA;AAJN;AAMI;EACE,mBAAA;EACA,oBAAA;EACA,UAAA;AAJN;AAMI;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;AAJN;;AAWA;EACE,aAAA;EACA,wBAAA;EACA,2BAAA;EACA,uBAAA;EACA,aAAA;AARF;AAUE;EACE,eAAA;EACA,iBAAA;EACA,kBAAA;AARJ;AASI;EACE,cAAA;AAPN;AAUE;EACE,YAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;AARJ;AASI;EACE,cAAA;AAPN;AASI;EACE,cAAA;EACA,yBAAA;AAPN;AAQM;EACE,cAAA;AANR;AAWE;EACE,eAAA;EACA,iBAAA;EACA,wBAAA;EACA,cAAA;AATJ;AAWE;EACE,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,8BAAA;AATJ;;AAaA;EACE,gBAAA;AAVF;;AAYA;EACE,aAAA;EACA,qBAAA;EACA,2BAAA;EACA,mBAAA;EACA,WAAA;AATF;AAWE;EACE,aAAA;EACA,qBAAA;EACA,2BAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,wBAAA;AATJ;AAWI;EACE,yBAAA;AATN;AAWI;EACE,yBAAA;AATN;AAYI;EACE,sBAAA;EACA,YAAA;EACA,gBAAA;EACA,+BAAA;EACA,eAAA;EACA,iBAAA;EACA,UAAA;EACA,4BAAA;AAVN;AAWM;EACE,cAAA;AATR;AAWM;EACE,aAAA;AATR;AAWM;EACE,+BAAA;AATR;AAWM;EACE,+BAAA;AATR;AAUQ;EACE,cAAA;AARV;AAYI;EACE,sBAAA;EACA,yBAAA;EACA,cAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,UAAA;EACA,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,gBAAA;AAVN;AAWM;EACE,cAAA;AATR;AAcE;EACE,aAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,0CAAA;EACA,YAAA;AAZJ;AAaI;EACE,8CAAA;AAXN;AAaI;EACE,mBAAA;EACA,+BAAA;AAXN;AAaI;EACE,mBAAA;EACA,4BAAA;AAXN","sourcesContent":["$metal-gray: #373f50;\n$demandjump-blue: #008CCE;\n\n.generate-parent{\n  width: 100%;\n}\n.insights-page-root {\n  padding: 25px 25px 25px 45px;\n  font-family: 'Source Sans Pro', sans-serif;\n  color: $metal-gray;\n\n  .generate-parent{\n    margin-bottom: 23px;\n  }\n\n\n  .insights-page-title {\n    font-style: normal;\n    font-weight: 400;\n    font-size: 30px;\n    line-height: 38px;\n    letter-spacing: 0.0025em;\n    margin-bottom: 23px;\n  }\n  .insights-info-message {\n    font-size: 16px;\n    line-height: 20px;\n    letter-spacing: 0.005em;\n    margin-bottom: 14px;\n\n  }\n  \n  .insights-list-container{\n    max-height: calc(100vh - 441px);\n    overflow-y: auto;\n    &::-webkit-scrollbar {\n      width: 5px;\n    }\n    &::-webkit-scrollbar-track {\n      border-radius: 10px;\n    }\n    &::-webkit-scrollbar-thumb {\n      background: #909BB3;\n      border-radius: 2.5px;\n      width: 5px;\n    }\n    .insights-list {\n      font-weight: 400;\n      font-size: 16px;\n      line-height: 20px;\n    }\n\n  }\n  \n\n}\n.advanced-options-container{\n  display: flex;\n  flex-flow: column nowrap;\n  justify-content: flex-start;\n  align-items: flex-start;\n  padding: 20px;\n\n  .dj-label {\n    font-size: 16px;\n    line-height: 20px;\n    margin-bottom: 4px;\n    &.error{\n      color: #B00020;\n    }\n  }\n  .dj-input {\n    width: 464px;\n    height: 48px;\n    font-size: 20px;\n    line-height: 25px;\n    background: #FFFFFF;\n    border: 1px solid #D3D7E0;\n    border-radius: 3px;\n    margin-bottom: 6px;\n    padding-left: 16px;\n    &::placeholder{\n      color: #909BB3;\n    } \n    &.error{\n      color: #B00020;\n      border: 1px solid #B00020;\n      &::placeholder{\n        color: #B00020;\n      } \n\n    }\n  }\n  .helper-text {\n    font-size: 12px;\n    line-height: 15px;\n    letter-spacing: 0.0125em;\n    color: #373F50;\n  }\n  .location-language-container{\n    display: flex;\n    flex-flow: row nowrap;\n    align-items: center;\n    justify-content: space-between;\n\n  }\n}\n.generate-insight-width-control{\n  max-width: 700px;\n}\n.generate-insight-container{\n  display: flex;\n  flex-flow: row nowrap;\n  justify-content: flex-start;\n  align-items: center;\n  width: 100%;\n\n  .generate-input-dropdown {\n    display: flex;\n    flex-flow: row nowrap;\n    justify-content: flex-start;\n    align-items: center;\n    border: 1px solid #D3D7E0;\n    border-radius: 3px;\n    height: 48px;\n    width: 100%;\n    font-size: 20px;\n    line-height: 25px;\n    display: flex;\n    align-items: center;\n    letter-spacing: 0.0125em;\n    \n    &.focused {\n      border: 1px solid $demandjump-blue;\n    }\n    &.error {\n      border: 1px solid #B00020;\n    }\n\n    .insight-input {\n      box-sizing: border-box;\n      border: none;\n      border-radius: 0;\n      border-right: 1px solid #D3D7E0;\n      font-size: 20px;\n      line-height: 25px;\n      width: 65%;\n      padding: 10px 16px 10px 16px;\n      &::placeholder{\n        color: #909BB3;\n      } \n      &:focus{\n        outline: none;\n      }\n      &.focused {\n        border-right: 1px solid $demandjump-blue;\n      }\n      &.error {\n        border-right: 1px solid #B00020;\n        &::placeholder{\n          color: #B00020;\n        }\n      }\n    }\n    .dropdown-button {\n      box-sizing: border-box;\n      background-color: #FFFFFF;\n      color: #909BB3;\n      border: none;\n      font-size: 20px;\n      line-height: 25px;\n      width: 35%;\n      display: flex;\n      flex-flow: row nowrap;\n      align-items: center;\n      justify-content: center;\n      padding: 10px 5px;\n      max-height: 100%;\n      &.error {\n        color: #B00020;\n      }\n    }\n    \n  }\n  .generate-button {\n    padding: 10px;\n    height: 48px;\n    background: #008CCE;\n    border-radius: 3px;\n    color: #FFFFFF;\n    margin-left: 16px;\n    font-weight: 600;\n    font-size: 20px;\n    line-height: 25px;\n    font-family: 'Source Sans Pro', sans-serif;\n    border: none;\n    &:hover {\n      box-shadow: 0px 4px 8px rgba(55, 63, 80, 0.25);\n    }\n    &:active{\n      background: #2ABBFF;\n      box-shadow: 0px 0px 3px #008CCE;\n    }\n    &:disabled{\n      background: #D3D7E0;\n      color: rgba(55, 63, 80, 0.3);\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
